<template>
  <pt-assigned-tasks-form class="pt-assigned-tasks-form__page"></pt-assigned-tasks-form>
</template>

<script>
import PtAssignedTasksForm from 'cps/appointment-application/pt-active-sign-notes/pt-assigned-tasks-form/withData'
export default {
  name: 'pt-assigned-tasks-form__view',
  components: {
    'pt-assigned-tasks-form': PtAssignedTasksForm
  }
}
</script>
